import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

export type RdwDetails = Record<string, string | undefined>;

const component = "RDW";

export const RdwQueryKeys = {
  details: (reg_number?: string) => backendQueryKey<RdwDetails>({ component, baseUrl: ENV.carBaseURL, endpoint: "/cars/rdw/details", params: { reg_number } })
};
